import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MeterAlarm } from '@app/energy-guard/models/alarms';
import { AuthService } from '@app/shared/services/auth.service';

@Component({
  selector: 'app-consumption-footer',
  templateUrl: './consumption-footer.component.html',
  styleUrls: ['./consumption-footer.component.scss'],
})
export class ConsumptionFooterComponent implements OnInit {
  @Output() download = new EventEmitter();
  @Output() offboard = new EventEmitter();
  @Input() hideDisclaimer: boolean = false;
  @Input() hideOffboarding: boolean = false;
  @Input() disableCsv: boolean = false;
  @Input() meter!: MeterAlarm;
  @Input() triggerDownloadWizard = true;

  isWizardVisible = false;
  isDownloadWizardEnabled: boolean = true;

  constructor(public authService: AuthService) {}

  ngOnInit() {
    this.isDownloadWizardEnabled = this.triggerDownloadWizard;
  }

  downloadCsv() {
    this.download.emit();
  }

  public openWizard(): void {
    this.isWizardVisible = true;
  }

  public closeWizard(): void {
    this.isWizardVisible = false;
  }

  offboardElement() {
    this.offboard.emit();
  }
}
